import Vue from 'vue'
import App from '@/views/Stockholder.vue'
import store from '@/store'
import Amplify from 'aws-amplify'
import '@aws-amplify/ui-vue'
import awsExports from '../aws-exports'
import vuetify from '@/plugins/vuetify'
import VueClipboard from 'vue-clipboard2'
import '@/assets/scss/style.scss'
Amplify.configure(awsExports)

Vue.config.productionTip = false
Vue.use(VueClipboard)

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
